<form class="w-12"
      name="newsletter_order-conf"
      method="POST"
      #form="ngForm">
    <cms-newsletter-block [newsletter]="newsletterCheckbox"
                          [submitButton]="false"
                          [isSuccessPage]="true"
                          (newsletterChange)="dataChangeHandle($event)"/>
</form>